import React from "react";
import { StyleSheet, Text, View } from "react-native";
import { colors } from "@constants/theme";
import t from "@constants/localization";
import Notification from "@assets/svg/Notification";

const PATH = "screens/MyDeliveries/DeliveryReturn/OverView";

const NoDeliveryCard = () => (
  <View style={styles.cardContainer}>
    <View style={[styles.card, styles.noDeliveryUpdates]}>
      <Notification diameter={80} />
      <Text style={styles.text1}>{t(`${PATH}/title`)}</Text>
      <Text style={styles.text2}>{t(`${PATH}/desc`)}</Text>
    </View>
  </View>
);

const styles = StyleSheet.create({
  cardContainer: {
    paddingHorizontal: 16,
    paddingVertical: 8,
    marginTop: 8,
  },
  card: {
    backgroundColor: colors.white,
    borderWidth: 0.5,
    borderRadius: 10,
    elevation: 2,
    borderColor: colors.lighterBlack,
  },
  text1: {
    fontFamily: "NotoSansDevanagari-SemiBold",
    fontSize: 16,
    lineHeight: 24,
    textAlign: "center",
    color: colors.mediumBlack,
    marginTop: 16,
  },
  text2: {
    fontFamily: "NotoSansDevanagari-Regular",
    fontSize: 12,
    lineHeight: 18,
    textAlign: "center",
    color: colors.lightBlack,
    maxWidth: "80%",
  },
  noDeliveryUpdates: {
    alignItems: "center",
    justifyContent: "center",
    padding: 48,
  },
});

export default NoDeliveryCard;
